import { render, staticRenderFns } from "./UserWatermarkOverlay.vue?vue&type=template&id=3f8e7482&scoped=true&"
import script from "./UserWatermarkOverlay.vue?vue&type=script&lang=ts&"
export * from "./UserWatermarkOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./UserWatermarkOverlay.vue?vue&type=style&index=0&id=3f8e7482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e7482",
  null
  
)

export default component.exports